/**
 * Contentsquare artificial page views for overlays (drawers, popups).
 *
 * Usage: add `data-artificial-page-view="<page-view-name>"` to the overlay
 * element. Open/close are tracked as `<name>-open` / `<name>-close`.
 * An overlay is "open" when it has the `open` attribute, or has no `inert`
 * attribute and is rendered.
 */
(function () {
  if (window.__artificialPageViewLoaded) return;
  window.__artificialPageViewLoaded = true;

  const ATTRIBUTE = 'data-artificial-page-view';
  const initialized = new WeakSet();

  function sendPageview(name) {
    if (!window._uxa) return;

    window._uxa.push(['setQuery', name, { lifespan: 'onNextPageviewOnly' }]);
    window._uxa.push(['trackPageview']);
  }

  function track(element) {
    if (initialized.has(element)) return;

    const name = element.getAttribute(ATTRIBUTE);

    if (!name) return;

    initialized.add(element);

    let isOpen = false;

    function checkState() {
      const nowOpen =
        element.hasAttribute('open') || (!element.hasAttribute('inert') && element.offsetParent !== null);

      if (nowOpen === isOpen) return;

      isOpen = nowOpen;
      sendPageview(`${name}-${nowOpen ? 'open' : 'close'}`);
    }

    new MutationObserver(checkState).observe(element, {
      attributes: true,
      attributeFilter: ['class', 'inert', 'open']
    });

    checkState();
  }

  function init() {
    document.querySelectorAll(`[${ATTRIBUTE}]`).forEach(track);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
